export default __webpack_public_path__ + "static/files/last try.e871246a.mp4";